import { MyBookingsHook } from "@models";
import { useStore } from "@stores";
import dayjs from "dayjs";

import { useEffect } from "react";

export const useMyFutureBookings = (): MyBookingsHook => {
  const { bookingStore } = useStore();
  const {
    myFutureBookingsLoading,
    myFutureBookings,
    myFutureBookingsSkipCount,
    myFutureBookingsTotalCount,
    myFutureBookingsMaxResultCount,
  } = bookingStore;

  useEffect(() => {
    bookingStore.getMyFutureBookings({
      future: true,
      date: dayjs().format(),
      skipCount: myFutureBookingsSkipCount,
      maxResultCount: myFutureBookingsMaxResultCount,
    });
    return () => {
      if (window.location.pathname === "/my-bookings") return;
      bookingStore.clearMyFutureBookings();
      bookingStore.setMyFutureBookingsSkipCount(0);
    };
  }, [bookingStore, myFutureBookingsSkipCount, myFutureBookingsMaxResultCount]);

  const loadMore = () => {
    bookingStore.setMyFutureBookingsSkipCount(
      myFutureBookingsSkipCount + myFutureBookingsMaxResultCount
    );
  };

  return {
    dataSource: Array.from(myFutureBookings.values()),
    loading: myFutureBookingsLoading,
    totalCount: myFutureBookingsTotalCount,
    maxResultCount: myFutureBookingsMaxResultCount,
    loadMore,
  };
};
